module.exports = {"name":"subscribeToWatchOrFollow","meta":{"description":"Changes \"Subscribe\" copy to be \"Watch\"","link":"https://trello.com/c/1jnzL93K"},"audiences":["allMembers"],"experimentAllocation":1,"defaultWeight":0,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"watch","weight":1},{"name":"follow","weight":0}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/subscribeToWatchOrFollow.json
// module id = i5iS
// module chunks = 13